import {commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();

const mutation = graphql`
mutation BusinessIdentityCreateMutation($input: CreateBusinessIdentityTInput!) {
  createBusinessIdentityT(input: $input) {
    businessIdentityT {
      accountId
      biId
    }
  }
}
`;

function commit(accountId, businessName, doingBusinessAs, businessType, businessClassification, website, ein, ipAddress, ssn, dateOfBirth,
                contactLastName, contactFirstName, contactEmail, contactPhone, address1, address2, city, state, country, postalCode,
                ctrTitle, ctrSsn, ctrDateOfBirth, ctrPassportNumber, ctrPassportCountry, ctrLastName, ctrFirstName, 
                ctrAddress1, ctrAddress2, ctrCity, ctrState, ctrCountry, ctrPostalCode) {
  const variables = {
    input: {
      businessIdentityT: {
        accountId,
        businessName,
        doingBusinessAs,
        businessType,
        businessClassification,
        website,
        ein,
        ipAddress,
        ssn,
        dateOfBirth,
        contactLastName,
        contactFirstName,
        contactEmail,
        contactPhone,
        address1,
        address2,
        city,
        state,
        country,
        postalCode,
        ctrTitle,
        ctrSsn, 
        ctrDateOfBirth,
        ctrPassportNumber,
        ctrPassportCountry,
        ctrLastName, 
        ctrFirstName,
        ctrAddress1, 
        ctrAddress2, 
        ctrCity, 
        ctrState, 
        ctrCountry, 
        ctrPostalCode
      }
    }
  }

  return new Promise((resolve, reject) => {
    commitMutation(
      abEnvironment.getEnvironment(), {
        mutation,
        variables,
        onCompleted: (response) => {
          //resolve(response.createAccountT.accountT);
          resolve(response);
        },
        onError: (error) => {
          reject(error);
        }
      });
  });
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { commit };
